export default __webpack_public_path__ + "static/media/overview.3f777239.svg";